import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import ScrollFloat from './ScrollFloat';
import './About.css';

const About = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.1 });
  
  return (
    <section id="about" className="about">
      <div ref={sectionRef} className={`about-container ${isVisible ? 'animate-in' : ''}`}>
        <div className="about-content">
          <div className="about-text">
            <span className="section-badge">About Us</span>
            <h2 className="section-title">
              <ScrollFloat speed={0.3} direction="up">We're Here to Bridge the Information Gap</ScrollFloat>
            </h2>
            <p className="about-description">
              At AIEx Partners, we understand that every company has a wealth of knowledge locked away 
              in documents, wikis, and knowledge bases. The challenge isn't having the information—it's 
              making it easily accessible to the people who need it, when they need it.
            </p>
            <p className="about-description">
              Our mission is to eliminate information gaps that slow down teams, frustrate employees, 
              and hinder growth. We've built a Microsoft Teams app that doesn't just store information—it makes 
              it instantly accessible through intelligent conversation right where your team already works.
            </p>
            <div className="about-values">
              <div className="value-item">
                <h3>Innovation</h3>
                <p>We leverage cutting-edge AI to solve real business problems</p>
              </div>
              <div className="value-item">
                <h3>Reliability</h3>
                <p>Enterprise-grade security and uptime you can count on</p>
              </div>
              <div className="value-item">
                <h3>Partnership</h3>
                <p>We work closely with you to ensure success</p>
              </div>
            </div>
          </div>
          <div className="about-visual">
            <div className="visual-card">
              <h3>Our Vision</h3>
              <p>Every employee should have instant access to the knowledge they need to excel at their job.</p>
            </div>
            <div className="visual-card">
              <h3>Our Approach</h3>
              <p>We tailor our solution to your company's unique needs, ensuring seamless integration with your existing workflows.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

